import * as PowerBI from 'powerbi-client';
import * as PowerBIExtensions from './powerbi-extensions';
import { DashboardPlugin } from './dashboard-plugin.interface';
import { BackendApiService } from '../backendApi.service';
import { MessageService, SlbMessage, SlbMessageBoxComponent, SlbSeverity } from '@slb-dls/angular-material/notification';
import { MatDialog } from '@angular/material/dialog';

export class DownloadPlugin implements DashboardPlugin {
  constructor(private backendApiService: BackendApiService, private downloadUrl: string, private messageService: MessageService, private dialog: MatDialog) {
  }

  private formatUserList(users: any[]): string {
    var result = '<ul>';
    for (const user of users) {
      result += `<li>${user.displayName} &lt;<a href="mailto:${user.email}">${user.email}</a>&gt;</li>`;
    }

    result += '</ul>';
    return result;
  }

  private showLimitedAccessNotification(messageHtml: string) {
    this.dialog.open(SlbMessageBoxComponent, {
      width: `500px`,
      height: 'auto',
      disableClose: true,
      data: { severity: SlbSeverity.Warning, summary: 'Limited Access Notification', detail: messageHtml, target: 'modal', asHtml: true },
    });
  }

  register(report: PowerBI.Embed): void {
    report.on('buttonClicked', async x => {
      if ((x.detail as any).title !== 'containersdownload') {
        return;
      }

      const containers = await PowerBIExtensions.getSelectedContainers(report);

      if (containers.length === 0) {
        const messageHtml = 'Nothing is currently selected for download.';
        this.showLimitedAccessNotification(messageHtml);
        return;
      }

      const downloadingMessage = <SlbMessage>{ severity: SlbSeverity.Info, detail: 'Authenticating...', target: 'modal' };
      this.messageService.add(downloadingMessage);
      const result: any = await this.backendApiService.authenticateDownload(containers).toPromise();
      this.messageService.clear(downloadingMessage);

      if (!result.success) {
        const messageHtml = 'Direct download of source data is currently limited to EHC data, but selected items do not contain any. ' +
          'To request additional permissions please contact one of the Coiled Tubing Analytics administrators: ' + this.formatUserList(result.adminUsers);
        this.showLimitedAccessNotification(messageHtml);
        return;
      }

      let message = 'Authentication succeeded. Download will start shortly';

      if (!result.canDownloadOtherData && result.hasOtherData) {
        message += '.<br> NOTE: Selected items contain non-EHC data that will not be included into the downloaded file. ' +
          'To request additional permissions please contact one of the Coiled Tubing Analytics administrators: ' + this.formatUserList(result.adminUsers);
        this.showLimitedAccessNotification(message);
      } else {
        this.messageService.add({ severity: SlbSeverity.Success, detail: message, target: 'modal' });
      }

      window.location.href = this.downloadUrl + 'byToken/' + result.token;
    });
  }
}
